<template>
    <add-edit-consequence></add-edit-consequence>
</template>

<script>
import AddEditConsequence from "@/layouts/components/risk-management/consequences/addedit-consequence.vue";

export default {
 components : {
   AddEditConsequence
 },
};
</script>